<template>
  <div class="table-theme-index">
    <div class="th-box-item" :class="{'active': activeItem === null}" @click="onClearColor">
      <i  class="theme-checkbox el-icon-success"
          :class="{active: activeItem === null}"></i>
      <p>初始样式</p>
    </div>
    <div v-for="(th, index) in themeList" :key="index" class="th-box-item" :class="{active: activeItem === th}" @click="onClickTheme(th)">
      <i  class="theme-checkbox el-icon-success"
          :class="{active: activeItem === th}"></i>
      <span class="th-color-picker" title="修改颜色" @click.stop>
        <el-color-picker v-model="th.color" size="mini" popper-class="picker-no-button" show-alpha
                         @active-change="onColorChange($event, th)"></el-color-picker>
      </span>
      <div :class="renderTableParentClass(th)" :style="renderTableParentStyle(th)">
        <table border="1" :class="th.themeClass" :style="`${th.cssVar}:${th.color}`">
          <tbody>
            <tr v-for="r in rowNum" :key="r">
              <td v-for="c in colNum" :key="c"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>{{th.name}}</p>
    </div>
  </div>
</template>
<script>
    const t_table_round_theme = 't-round';
    export default {
        data () {
            return {
                activeItem: null,
                themeList: [
                    {name: '圆角', themeClass: t_table_round_theme, conflictTheme: [], color: 'red', cssVar: '--t-border-color', cssVarRadius:
                            '--t-border-radius', borderRadius: 10},
                    {
                        name: '隔行变色01',
                        themeClass: 'even-row',
                        conflictTheme: ['odd-row', 'even-col', 'odd-col'],
                        color: 'red',
                        cssVar: '--t-cell-color'
                    },
                    {
                        name: '隔行变色02',
                        themeClass: 'odd-row',
                        conflictTheme: ['even-row', 'even-col', 'odd-col'],
                        color: 'red',
                        cssVar: '--t-cell-color'
                    },
                    {
                        name: '隔列变色01',
                        themeClass: 'even-col',
                        conflictTheme: ['odd-col', 'even-row', 'odd-row'],
                        color: 'red',
                        cssVar: '--t-cell-color'
                    },
                    {
                        name: '隔列变色02',
                        themeClass: 'odd-col',
                        conflictTheme: ['even-col', 'even-row', 'odd-row'],
                        color: 'red',
                        cssVar: '--t-cell-color'
                    },
                    {
                        name: '列边框线',
                        themeClass: 'border-color-col',
                        conflictTheme: ['border-color-row'],
                        color: 'red',
                        cssVar: '--t-cell-border-color'
                    },
                    {
                        name: '行边框线',
                        themeClass: 'border-color-row',
                        conflictTheme: ['border-color-col'],
                        color: 'red',
                        cssVar: '--t-cell-border-color'
                    },
                    {
                        name: '首列边框线', themeClass: 'border-1-col', conflictTheme: ['border-color-col', 'border-color-row'], color: 'red', cssVar:
                            '--t-col-border-color'
                    },
                ],
                rowNum: 6,
                colNum: 5
            };
        },
        computed:{
            isEmpty(){
                return this.activeItem1 === null && this.activeItem2 === null;
            }
        },
        destroyed(){
            this.activeItem = null;
            this.removeEvent();
        },
        created () {
            this.initEvent();
        },
        methods: {
            initEvent(){
                this.eventBus.$on('_clearActiveThemeStatus', this._clearActiveThemeStatus);
            },
            removeEvent(){
                this.eventBus.$off('_clearActiveThemeStatus', this._clearActiveThemeStatus);
            },
            _clearActiveThemeStatus(){
                this.activeItem = null;
            },
            isActive (th) {
                if(th.themeClass === t_table_round_theme){
                    return th === this.activeItem1;
                }else{
                    return th === this.activeItem2;
                }
            },
            renderTableParentClass(th){
                if(th.themeClass === 't-round'){
                    return th.themeClass
                }
                return null;
            },
            renderTableParentStyle(th){
                if(th.themeClass === t_table_round_theme){
                    return `${th.cssVar}:${th.color};${th.cssVarRadius}: ${th.borderRadius}px`
                }
                return null;
            },
            onClickTheme (th) {
                if(th.themeClass === t_table_round_theme){
                    this.toggleTableBorder(th);
                }else{
                    this.toggleTheme(th);
                }
            },
            onColorChange (color, th) {
                th.color = color;
                this.setTableColor(th);
            },
            onClearColor () {
                this.clearTableColor();
                this.activeItem = null;
                this.clearTableBorder()
            },
            toggleTableBorder(item){
                let table = tinymce.activeEditor.getBody().querySelector('table');
                if (!table) {
                    return;
                }
                let fromOtherItem = item !== this.activeItem;
                let hasTableBorder = this.getBorderRadiusTable();
                if(fromOtherItem || !hasTableBorder){
                    this.setTableBorder(item);
                    this.activeItem = item;
                }else{
                    this.activeItem = null;
                    this.setActiveByTableClass([...table.classList]);
                    this.clearTableBorder(item);
                }
            },
            toggleTheme (item) {
                let table = tinymce.activeEditor.getBody().querySelector('table');
                if (!table) {
                    return;
                }
                let {themeClass, cssVar, color, conflictTheme} = item;
                let classList = table.classList;
                if (classList.contains(themeClass)) {
                    classList.toggle(themeClass);
                    this.activeItem = item !== this.activeItem ? item : null;
                    !this.activeItem && this.setActiveByBorderClass();
                    return;
                } else {
                    this.activeItem = item;
                    classList.add(themeClass);
                    table.style.setProperty(cssVar, color);
                    table.setAttribute('data-mce-style', table.style.cssText);
                }
                this.removeConflictTheme(classList, conflictTheme);
            },
            setActiveByBorderClass(){
                let hasBorder = this.getBorderRadiusTable();
                if(hasBorder){
                    this.activeItem = this.themeList.filter((item) => {
                        return item.themeClass === t_table_round_theme;
                    })[0]
                }
            },
            setActiveByTableClass(classList){
                let idx = this.themeList.findIndex((item) => {
                    return classList.indexOf(item.themeClass) > -1
                });
                this.activeItem = idx > -1 ? this.themeList[idx] : null;
            },
            removeConflictTheme (classList, conflictTheme) {
                conflictTheme && conflictTheme.forEach((className) => {
                    if (classList.contains(className)) {
                        classList.remove(className);
                    }
                })
            },
            setTableColor (item) {
                let table = tinymce.activeEditor.getBody().querySelector('table');
                if (!table) {
                    return;
                }
                let {themeClass, color, cssVar, conflictTheme} = item;
                if(themeClass === t_table_round_theme){
                    this.setTableBorder(item);
                    return;
                }
                let classList = table.classList;
                if (!classList.contains(themeClass)) {
                    classList.add(themeClass);
                }
                table.style.setProperty(cssVar, color);
                table.setAttribute('data-mce-style', table.style.cssText);
                this.removeConflictTheme(classList, conflictTheme);
            },
            setTableBorder(item){
                let table = tinymce.activeEditor.getBody().querySelector('table');
                if (!table) {
                    return;
                }
                let borderTable = this.getBorderRadiusTable();
                if(borderTable) {
                    borderTable.style = `${item.cssVar}: ${item.color};${item.cssVarRadius}:${item.borderRadius}px`;
                }else{
                    borderTable = document.createElement('div');
                    borderTable.className = item.themeClass;
                    borderTable.style = `${item.cssVar}: ${item.color};${item.cssVarRadius}:${item.borderRadius}px`;
                    borderTable.innerHTML = table.outerHTML;
                    table.outerHTML = borderTable.outerHTML;
                }
            },
            getBorderRadiusTable(){
                return tinymce.activeEditor.getBody().querySelector(`.${t_table_round_theme}`);
            },
            clearTableBorder(){
                let table = tinymce.activeEditor.getBody().querySelector('table');
                if (!table) {
                    return;
                }
                let borderTable = this.getBorderRadiusTable();
                if(borderTable){
                    borderTable.outerHTML = table.outerHTML;
                }
            },
            clearTableColor () {
                let table = tinymce.activeEditor.getBody().querySelector('table');
                if (!table) {
                    return;
                }
                // psd解析出来的表格数据默认设置了className 'psd-table'
                let defClass = table.className.indexOf('psd-table') > -1 ? 'psd-table' : '';
                table.className = defClass;
            }
        }
    }
</script>
<style lang="scss">
  @import "table-theme-index.scss";
</style>